// THE QUEUES (owner, 2026-09-15 and 2026-09-26). "Fetch latest reports" puts a company in
// cvrreportqueue; "Fetch this company from CVR" puts a CVR number in cvrcompanyqueue. The
// agent checks both every 30 s and removes a row when it is done.
//
// The site is the guest (B09), and the guest cannot write. So a button sends
// CALL queue_company(…) / CALL queue_reports(…): the two functions run as the user web,
// check their arguments again and write the row (db/access.js, owner 2026-09-28). The
// guest reads the row, to show "Waiting for the agent…".
import { eq, quote, select } from './sql.js';

export const COMPANY_QUEUE = 'cvrcompanyqueue';
export const REPORT_QUEUE = 'cvrreportqueue';

const CVR = /^[0-9]{8}$/;
const MAX_NAME = 500;

/** The CVR number in a page URL, or null. An enhedsnummer has 10 digits. */
export function cvrOfId(id) {
  return CVR.test(String(id ?? '')) ? Number(id) : null;
}

function requireCvr(cvr) {
  if (!Number.isSafeInteger(cvr) || !CVR.test(String(cvr))) throw new Error(`${JSON.stringify(cvr)} is not a CVR number.`);
  return cvr;
}

/** Ask the agent for a company that kinedb does not have. */
export function companyCallSql(cvr) {
  return `CALL queue_company(${requireCvr(cvr)})`;
}

/** Ask the agent for the reports of a company. */
export function reportsCallSql({ enhedsNummer, cvr, name = '' }) {
  if (!Number.isSafeInteger(enhedsNummer) || enhedsNummer < 1) {
    throw new Error('This company has no enhedsnummer, so its reports cannot be fetched.');
  }
  requireCvr(cvr);
  if (typeof name !== 'string' || name.length > MAX_NAME) throw new Error('The name of the company is not valid.');
  return `CALL queue_reports(${enhedsNummer}, ${cvr}, ${quote(name)})`;
}

/** The row of a CVR number `{attempts, lastError}`. */
export function companyRequestRowSql(cvr) {
  return select({ from: COMPANY_QUEUE, fields: ['attempts', 'lastError'], where: eq('cvr', requireCvr(cvr)), limit: 1 });
}
